/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scan_RiceInputs */

const en_portal_scan_rice = /** @type {(inputs: Portal_Scan_RiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rice 150 g`)
};

const pl_portal_scan_rice = /** @type {(inputs: Portal_Scan_RiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ryż 150 g`)
};

/**
* | output |
* | --- |
* | "Rice 150 g" |
*
* @param {Portal_Scan_RiceInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_scan_rice = /** @type {((inputs?: Portal_Scan_RiceInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scan_RiceInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_scan_rice(inputs)
	return en_portal_scan_rice(inputs)
});